export const ORDERS_CREATE                           = '@@ORDER_CREATE'
export const LOAD_ORDER_FROM_LOCALSTORAGE            = '@@LOAD_ORDER_FROM_LOCALSTORAGE'
export const ORDERS_PUSH                             = '@@ORDERS_PUSH'
export const ORDERS_CLEAR                            = '@@ORDERS_CLEAR'


// WEBPACK FOOTER //
// ./src/features/OrderDetails/actionTypes.js